import { Component, computed, signal, Signal } from '@angular/core';
import { DataItemTemplate } from '../../../templates/data-item-template/data-item-template';
import { Icon } from '../../icon/icon';
import { UnitType } from '../../../models/unit.model';
import { ElevationPipe } from '../../../pipes/elevation-pipe';

@Component({
  selector: 'li[app-positive-slope-data-item-block]',
  imports: [Icon, DataItemTemplate, ElevationPipe],
  template: `
    <app-data-item-template [dataBlock]="dataBlock()">
      <app-icon [size]="iconSize()" class="icon" icon="slope" />
      <p class="name">{{ value() | elevation: unit() : 'unit' }}</p>
      <p class="value">{{ value() | elevation: unit() : 'value' : 0 }}</p>
    </app-data-item-template>
  `,
  styleUrl: './positive-slope-data-item-block.scss',
})
export class PositiveSlopeDataBlockItem extends DataItemTemplate {
  value: Signal<number> = computed(
    () => this.webSocketService.broadcastData()?.data.positiveSlope || 0,
  );
  unit: Signal<UnitType> = signal((localStorage.getItem('unit') as UnitType) || 'metric');
}
